// extracted by mini-css-extract-plugin
module.exports = {"link__logo":"HeaderLink_link__logo__2m3L6","link__logo__text":"HeaderLink_link__logo__text__3QTXF","link__docs":"HeaderLink_link__docs__1JBTx"};